export const MUIThemeOptions = {
  palette: {
    type: "light",
    primary: {
      main: "#14213d",
    },
    secondary: {
      main: "#fca311",
    },
    error: {
      main: "#e63946",
    },
  },
  typography: {
    fontFamily: "Montserrat",
  },
};

export default MUIThemeOptions;
